import SectionHeading from "./SectionHeading";

const groups = [
  {
    key: "平台",
    icon: "ri-megaphone-line",
    color: "bg-primary-500",
    items: [
      { role: "官方公告", text: "将持续开展专项治理，打击违规内容，并公开阶段性处置数据。" },
      { role: "客服口径", text: "审核结果基于平台规范，可在「意见反馈」中提交申诉，一般 48 小时内处理。" },
    ],
  },
  {
    key: "监管",
    icon: "ri-government-line",
    color: "bg-accent-600",
    items: [
      { role: "约谈要求", text: "强调平台应加强内容审核与未成年人保护，压实主体责任、完善长效机制。" },
      { role: "整改反馈", text: "督促定期报送整改进展，要求处置标准透明、规则公开。" },
    ],
  },
  {
    key: "创作者",
    icon: "ri-camera-lens-line",
    color: "bg-secondary-700",
    items: [
      { role: "流量受损方", text: "流量骤降但拿不到依据，只能反复申诉，「黑箱算法」让我们没有安全感。" },
      { role: "守规者", text: "规则频繁更新，合规成本变高，希望平台给更清晰、可预期的指引。" },
    ],
  },
  {
    key: "网友",
    icon: "ri-chat-smile-3-line",
    color: "bg-foreground-800",
    items: [
      { role: "内容质量派", text: "该管的还是要管，只是别误伤正常内容，尺度应该让人看得懂。" },
      { role: "旁观记录派", text: "把每次处罚、下架都记下来对比，等时间久了自然能看出门道。" },
    ],
  },
];

export default function Voices() {
  return (
    <section id="voices" className="w-full border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          kicker="多方视角汇聚"
          title="各方说法 · 一次看全"
          desc="平台、监管、创作者与普通网友，立场各不相同。我们不替谁定调，只把声音收齐，还原事件的多面性。"
        />

        <div className="mt-8 grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {groups.map((g) => (
            <div
              key={g.key}
              className="flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50"
            >
              <div className={`flex items-center gap-2 px-4 py-3 text-background-50 ${g.color}`}>
                <i className={`${g.icon} text-base`} />
                <h3 className="font-label text-sm font-bold">{g.key}的说法</h3>
              </div>
              <div className="flex flex-1 flex-col gap-3 p-4">
                {g.items.map((it) => (
                  <div key={it.role} className="rounded-lg bg-secondary-50 p-3">
                    <p className="font-label text-[11px] font-semibold text-secondary-900">{it.role}</p>
                    <p className="mt-1 text-[13px] leading-relaxed text-foreground-700">{it.text}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 rounded-lg border border-primary-200 bg-primary-50 px-4 py-3 text-[13px] leading-relaxed text-primary-900">
          <i className="ri-information-line mr-1.5" />
          以上立场均来自公开讨论的整理与归纳，仅供了解「各方说法」，不代表本页对任何争议作出认定。
        </p>
      </div>
    </section>
  );
}